import { HeidiLogoMark } from '@heidi/design-system/heidi-logo-mark';
import { TypographyH2, TypographyP2 } from '@heidi/design-system/typography';
import { type TranslationKey, useTranslations } from '@heidi/runtime/i18n';

interface SignInModalHeaderProps {
  additionalSubtitle?: string;
}

/**
 * Shared header component for sign-in modals.
 * Displays the brand icon, title, subtitle, and optional additional subtitle.
 */
export function SignInModalHeader({ additionalSubtitle }: SignInModalHeaderProps) {
  const { t } = useTranslations();

  return (
    <div className="flex flex-col items-start gap-6">
      <div data-testid="brand-icon">
        <HeidiLogoMark className="size-[50px]" artwork="standard" />
      </div>
      <div className="flex flex-col items-start gap-1 text-left">
        <TypographyH2>{t('signup.title')}</TypographyH2>
        <TypographyP2>{t('signup.subtitle')}</TypographyP2>
        {additionalSubtitle && (
          <TypographyP2>{t(additionalSubtitle as TranslationKey)}</TypographyP2>
        )}
      </div>
    </div>
  );
}
